/** Local-time date helpers. Log keys are 'YYYY-MM-DD' in the user's local zone (moment on mobile). */
import moment from 'moment'

export const DATE_FMT = 'YYYY-MM-DD'

export function toDateStr(d: Date): string {
  return moment(d).format(DATE_FMT)
}

export function todayStr(): string {
  return moment().format(DATE_FMT)
}

export function parseDateStr(s: string): Date {
  return moment(s, DATE_FMT).toDate()
}

export function addDays(s: string, n: number): string {
  return moment(s, DATE_FMT).add(n, 'days').format(DATE_FMT)
}

/** Monday-based start of the week containing `s`. */
export function startOfWeek(s: string): string {
  return moment(s, DATE_FMT).isoWeekday(1).format(DATE_FMT)
}

export function weekDays(weekStart: string): string[] {
  return Array.from({ length: 7 }, (_, i) => addDays(weekStart, i))
}

export function isToday(s: string): boolean {
  return s === todayStr()
}

export function isFuture(s: string): boolean {
  return s > todayStr()
}

/** ISO timestamp for `date` at the current wall-clock time (or noon when the date isn't today). */
export function isoAtDate(date: string, time?: string): string {
  if (time) return moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm').toISOString()
  const now = moment()
  if (date === now.format(DATE_FMT)) return now.toISOString()
  return moment(date, DATE_FMT).hour(12).minute(0).second(0).toISOString()
}

/** 'HH:mm' local for an ISO timestamp (input[type=time] value). */
export function timeOfIso(iso: string): string {
  const m = moment(iso)
  return m.isValid() ? m.format('HH:mm') : moment().format('HH:mm')
}

export function formatTime(iso: string): string {
  const m = moment(iso)
  return m.isValid() ? m.format('LT') : ''
}

export function formatDateLong(date: string): string {
  return moment(date, DATE_FMT).format('dddd, MMM D')
}

export function formatDateShort(date: string): string {
  return moment(date, DATE_FMT).format('MMM D')
}
